<section>
  <div class="d-flex">
    <h4 class="template-name-container">{{templateName}}</h4>
  </div>
</section>
<mat-toolbar class="toolbar">
  <div class="vw-10">
    <button class="mr-3" mat-icon-button [matTooltip]="'reportPreview.back' | translate" matTooltipPosition="right" (click)='cancel()'>
      <mat-icon class="mat-icon">keyboard_backspace</mat-icon>
    </button>
    <button *ngIf="isVisol" mat-flat-button color="primary" class="mr-2 add-button" (click)='openImageUploadDialog()'>
      <mat-icon class="mr-1">add</mat-icon>{{'reportPreview.images' | translate}}
    </button>
  </div>
  <div class="vw-35 text-center">

    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.cutElements' | translate" matTooltipPosition="right" (click)="cutSelectedElements()"
            [hidden]="!selectedPropPanels || selectedPropPanels.length === 0 || isSelectedElementPageOnly" [ngClass]="{'btn-disabled': !selectedPropPanels || selectedPropPanels.length === 0}">
      <i class="fas fa-cut menu-icon"></i>
    </button>

    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.copyElements' | translate" matTooltipPosition="right" (click)="copySelectedElements()"
            [hidden]="!selectedPropPanels || selectedPropPanels.length === 0 || isSelectedElementPageOnly" [ngClass]="{'btn-disabled': !selectedPropPanels || selectedPropPanels.length === 0}">
      <i class="fas fa-copy menu-icon"></i>
    </button>

    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.pasteElements' | translate" matTooltipPosition="right" (click)="PasteCopiedElements()"
            [hidden]="selectedElements?.length === 0 || isSelectedElementPageOnly" [ngClass]="{'btn-disabled': selectedElements?.length === 0}">
      <i class="fas fa-paste menu-icon"></i>
    </button>

    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.deleteSelection' | translate" matTooltipPosition="right" [ngClass]="{'btn-disabled': !selectedPropPanels || selectedPropPanels.length === 0}"
            (click)="deleteElement()" [hidden]="!selectedPropPanels || selectedPropPanels.length === 0">
      <i class="fas fa-trash menu-icon"></i>
    </button>

    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.Undo' | translate" matTooltipPosition="right"
            (click)="undoElement()" [disabled]="designService.templateForUndo.length == 0" [ngClass]="{'btn-disabled': designService.templateForUndo.length == 0}">
      <i class="fas fa-undo menu-icon"></i>
    </button>
    <button mat-icon-button class="mx-1" [matTooltip]="'reportPreview.Redo' | translate" matTooltipPosition="right"
            (click)="redoElement()" [disabled]="designService.templateForRedo.length === 0" [ngClass]="{'btn-disabled': designService.templateForRedo.length === 0}">
      <i class="fas fa-redo menu-icon"></i>
    </button>
    <mat-slide-toggle color="primary" class="mx-1" [(ngModel)]="designService.checkedRuler">{{'reportPreview.ruler' | translate}}</mat-slide-toggle>
  </div>
  <div class="vw-45">
    <ng-container class="form-fields-container" *ngIf="!isVisol">
      <mat-form-field  class="form-field" subscriptSizing="dynamic" appearance="fill" [matTooltip]="'objects.' + reportType | translate" matTooltipPosition="below">
        <mat-label>{{'reportPreview.reportType' | translate}}</mat-label>
        <input matInput disabled  [(ngModel)]="reportType">
      </mat-form-field>
      <mat-form-field class="form-field" subscriptSizing="dynamic" appearance="fill" [matTooltip]="translatedEquipmentType" matTooltipPosition="below">
        <mat-label>{{'reportPreview.equipmentType' | translate}}</mat-label>
        <input matInput disabled  [(ngModel)]="translatedEquipmentType">
      </mat-form-field>
    </ng-container>
    <mat-form-field class="select-box" subscriptSizing="dynamic" *ngIf="!isVisol">
      <mat-label>{{'reportPreview.selectApp' | translate}}</mat-label>
      <mat-select [(ngModel)]="application" (ngModelChange)="changeApplication()" disableOptionCentering>
        <mat-option *ngFor="let application of applications" [value]="application">
          {{application}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-box" subscriptSizing="dynamic" *ngIf="application === 'ViSOL'">
      <mat-label>{{'reportPreview.selectTemplates' | translate}}</mat-label>
      <mat-select #inspectors [formControl]="subjectModelsCtrl" multiple
                  [disableOptionCentering]="true" (selectionChange)="changeTargetSubjectModels()">
        <mat-select-trigger>
          {{subjectModelsCtrl.value.length > 0 ? getSortedSubjectModels()[0].subjectModel.name : ''}}
          <span *ngIf="subjectModelsCtrl.value.length > 1">
            (+{{subjectModelsCtrl.value.length - 1}} others)
          </span>
        </mat-select-trigger>
        <mat-option [ngClass]="{'is-disabled-model': !subjectModel.subjectModel.isValid}" *ngFor="let subjectModel of subjectModelsMaster" [value]="subjectModel">
          <span class="option-label-overflow" [matTooltip]="subjectModel.subjectModel.name" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
            {{subjectModel.subjectModel.name}}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!--<span *ngIf="application.toUpperCase()==='VISOL' && isModelSelectedNone()">
      <b>&nbsp; &nbsp; Select subject model that will use this report template.</b>
    </span>-->
  </div>
  <div class="d-flex vw-10">
    <button mat-icon-button class="mr-3" color="primary" (click)="openTemplateSettings()" [matTooltip]="'reportPreview.templatesettings' | translate" matTooltipPosition="right">
      <i class="fas fa-cogs menu-icon"></i>
    </button>
    <button mat-icon-button class="mr-3" color="primary" (click)="saveTemplate()" [matTooltip]="'reportPreview.savetemplate' | translate" matTooltipPosition="right"
            [disabled]="buttonDisabled()" [ngClass]="{'btn-disabled': buttonDisabled()}">
      <i class="fas fa-save menu-icon"></i>
    </button>
  </div>
</mat-toolbar>
<div class="validate-error" [ngClass]="{'scroll': isScroll()}">
  <div class="validate-error-title" *ngFor="let error of validateErrorList"
     (click)="onClickErrorList($event, error)" [style.height]="getErrorListHeight(error.validationErrorMessage.length)">
    <mat-icon class="error-icon">report_problem</mat-icon>
    <span class="list-title" *ngIf="error.pageIndex !== undefined">{{'reportPreview.page' | translate}} : {{error.pageIndex + 1}}</span>
    <span class="list-title" *ngIf="error.pageIndex === undefined && error.location">{{ 'objects.' +error.location | translate }}</span>
    <span class="list-title">{{'reportPreview.type' | translate}} : {{ 'objects.' +error.type | translate }}</span>
    <div>
      <div class="validate-error-message" *ngFor="let message of error.validationErrorMessage">
        <span class="list-message" *ngIf="message">{{ 'objects.' +message.name | translate }} : {{ 'objects.errormessage_' +message.errorMessage | translate }}</span><br>
      </div>
    </div>
  </div>
</div>
<div class="d-flex report-preview-container">
  <div class="add-element-button d-flex" [style.top]="getTopValue('add')" *ngIf="!showAllItems && !addElements" (click)="addElements = !addElements" [matTooltip]="'reportPreview.addelements' | translate" matTooltipPosition="right">
    <mat-icon class="px-2">add</mat-icon>
  </div>
  <div class="navigator-button d-flex" [style.top]="getTopValue('navigator')" *ngIf="!showAllItems && !addElements" (click)="showAllItems = 'showallelements'" [matTooltip]="'reportPreview.navigatorelements' | translate" matTooltipPosition="right">
    <mat-icon class="px-2">list</mat-icon>
  </div>

  <aside *ngIf="addElements" class="side-menu">
    <div class="d-flex side-menu__header">
      <header class="flex-grow-1">
        <span>{{'reportPreview.addelements' | translate}}</span>
      </header>
      <mat-icon (click)="addElements = !addElements">close</mat-icon>
    </div>
    <div class="side-menu__cursor">
      <ul class="side-menu__list">
        <li (mousedown)="onSelectObjectMenu('page', 'add')">
          <button class="elements-button" mat-flat-button color="primary" [disabled]="!permissionForActions['page']['add']">
            <mat-icon class="elements-icon">crop_portrait_fill</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.page' | translate}}</span>
          </div>
        </li>

        <li *ngIf="!isVisol" (mousedown)="onSelectObjectMenu('section', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['section']" [disabled]="!permissionForActions['section']['draw']">
            <mat-icon class="elements-icon">extension</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.section' | translate}}</span>
          </div>
        </li>

        <li (mousedown)="onSelectObjectMenu('text', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['text']" [disabled]="!permissionForActions['text']['draw']">
            <mat-icon class="elements-icon">title</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.text' | translate}}</span>
          </div>
        </li>

        <li (mousedown)="onSelectObjectMenu('line', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['line']" [disabled]="!permissionForActions['line']['draw']">
            <mat-icon class="elements-icon">remove</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.line' | translate}}</span>
          </div>
        </li>

        <li (mousedown)="onSelectObjectMenu('image', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['image']" [disabled]="!permissionForActions['image']['draw']">
            <mat-icon class="elements-icon">image</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.image' | translate}}</span>
          </div>
        </li>

        <li (mousedown)="onSelectObjectMenu('rectangle', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['rectangle']" [disabled]="!permissionForActions['rectangle']['draw']">
            <mat-icon class="elements-icon" md-48>crop_7_5</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.rectangle' | translate}}</span>
          </div>
        </li>

        <li *ngIf="!isVisol" (mousedown)="onSelectObjectMenu('interactiveIso', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['interactiveIso']" [disabled]="!permissionForActions['interactiveIso']['draw']">
            <mat-icon class="elements-icon" md-48>layers</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.interactiveISO' | translate}}</span>
          </div>
        </li>

        <li *ngIf="!isVisol" (mousedown)="onSelectObjectMenu('table', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['table']" [disabled]="!permissionForActions['table']['draw']">
            <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.table' | translate}}</span>
          </div>
        </li>

        <li *ngIf='!isVisol || getApplication() === "IPM"' (mousedown)="onSelectObjectMenu('measurementPoint', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['measurementPoint']" [disabled]="!permissionForActions['measurementPoint']['draw']">
            <mat-icon class="elements-icon">table_chart</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.measurementResults' | translate}}</span>
          </div>
        </li>

        <li *ngIf='!isVisol || getApplication() === "IPM"' (mousedown)="onSelectObjectMenu('visualEvents', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['visualEvents']" [disabled]="!permissionForActions['visualEvents']['draw']">
            <mat-icon class="elements-icon">photo_album</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.visualEvents' | translate}}</span>
          </div>
        </li>

        <li *ngIf="!isVisol" (mousedown)="onSelectObjectMenu('signature', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['signature']" [disabled]="!permissionForActions['signature']['draw']">
            <i class="fas fa-signature"></i>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.signature' | translate}}</span>
          </div>
        </li>

        <li *ngIf="isVisol" (mousedown)="onSelectObjectMenu('summary', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['summary']" [disabled]="!permissionForActions['summary']['draw']">
            <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.summaryTable' | translate}}</span>
          </div>
        </li>
        <li *ngIf="isVisol" (mousedown)="onSelectObjectMenu('subtotal', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['subtotal']" [disabled]="!permissionForActions['subtotal']['draw']">
            <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.subtotalTable' | translate}}</span>
          </div>
        </li>
        <li *ngIf="isVisol" (mousedown)="onSelectObjectMenu('picture', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['picture']" [disabled]="!permissionForActions['picture']['draw']">
            <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.pictureTable' | translate}}</span>
          </div>
        </li>
        <li *ngIf="isVisol" (click)="onSelectObjectMenu('dataPlate', 'draw')">
          <button class="elements-button" mat-flat-button [color]="buttonColors['dataPlate']" [disabled]="!permissionForActions['dataPlate']['draw']">
            <mat-icon class="elements-icon" md-48>grid_on</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.dataPlate' | translate}}</span>
          </div>
        </li>

        <li *ngIf='getApplication() === "IPM"' (mousedown)="onSelectObjectMenu('dropDownList', 'draw');$event.preventDefault()">
          <button class="elements-button" mat-flat-button [color]="buttonColors['dropDownList']" [disabled]="!permissionForActions['dropDownList']['draw']">
            <mat-icon class="elements-icon" md-48>list_alt</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{'reportPreview.dropdownList' | translate}}</span>
          </div>
        </li>
      </ul>
      <dev *ngIf='!isVisol || getApplication() === "IPM"'> 
        <button *ngIf='!isVisol || getApplication() === "IPM"' mat-raised-button class="my-1" color="primary" (click)="redirectCustomELement()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          {{'reportPreview.addcustomelement' | translate}}
        </button>
      </dev>
      <ul *ngIf="!isVisol" class="side-menu__list">
        <li *ngFor="let elementdetail of designService.reportCustomTemplates" (mousedown)="onSelectObjectMenu('customElement', 'draw', elementdetail.id, elementdetail.name);$event.preventDefault()">
          <button class="elements-button" mat-flat-button color="primary">
            <mat-icon class="elements-icon" md-48>ballot</mat-icon>
          </button>
          <div class="flex-grow-1">
            <span>{{elementdetail.name}}</span>
          </div>
          <button mat-icon-button [matTooltip]="'reportPreview.edit' | translate"  matTooltipPosition="left" [routerLink]="['/create-custom-element']" [queryParams]="{name: elementdetail.name, id: elementdetail.id }">
            <mat-icon class="mat-icon">edit</mat-icon>
          </button>
          <button mat-icon-button [matTooltip]="'reportPreview.delete' | translate" matTooltipPosition="left" (click)="deleteCustomElement(elementdetail.id)" >
            <mat-icon class="mat-icon" color="warn">delete</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </aside>

  <aside *ngIf="showAllItems === 'showallelements'" class="side-menu">
    <div class="d-flex side-menu__header">
      <header class="flex-grow-1">
        <span>{{'reportPreview.navigator' | translate}}</span>
      </header>
      <mat-icon (click)="showAllItems = ''">close</mat-icon>
    </div>
    <div class="side-menu__cursor navigator">
      <ul class="side-menu__navigator" *ngFor="let res of designService.navigatorElements; let i = index">
        <li (click)="navigatorToggle[i]=!navigatorToggle[i]">
          <mat-icon>{{navigatorToggle[i] ? 'expand_more' : 'chevron_right'}}</mat-icon>{{res.name}}
        </li>
        <ng-container *ngIf="navigatorToggle[i]">
          <ul *ngFor="let elementdetail of res.elementsDetails;">
            <li *ngIf="elementdetail.elements.length > 0" (click)="elementdetail.isVisible=!elementdetail.isVisible">
              <mat-icon>{{elementdetail.isVisible ? 'expand_more' : 'chevron_right'}}</mat-icon>{{ 'objects.' + elementdetail.location | translate }}
            </li>
            <ng-container *ngIf ="elementdetail.isVisible">
              <ul *ngFor="let element of elementdetail.elements;">
                <li (click)="element.isVisible=!element.isVisible">
                  <mat-icon>{{element.isVisible ? 'expand_more' : 'chevron_right'}}</mat-icon>{{ 'objects.' + element.elementName | translate }}
                </li>
                <ng-container *ngIf="element.isVisible">
                  <ul *ngFor="let res of element.elementData">
                    <li class="navigator-elements" (click)="selectElement(res, $event)">{{ res.name }}</li>
                  </ul>
                </ng-container>
              </ul>
            </ng-container>
          </ul>
        </ng-container>
      </ul>
    </div>
  </aside>

  <div class="flex-grow-1 report-preview-div">
    <div class="report-content" (click)="onClick($event)">
      <div class="report-preview" id="pageScroll" (scroll)="scrollEvent($event)">
        <app-report-page-container class="report-page-outer" (mousedown)="onMouseDown($event)" *ngFor="let pageKey of reportPageKeys" [pageKey]="pageKey">
        </app-report-page-container>
      </div>
    </div>
  </div>

  <div class="property-preview-button d-flex" [style.top]="getTopValue('property')" *ngIf="!showMenu || showMenu === 'elements'" (click)="showMenu = 'properties'" [matTooltip]="'reportPreview.elementssettings' | translate" matTooltipPosition="left">
    <mat-icon class="mr-2">palette</mat-icon>
  </div>
  <aside [hidden]="showMenu !== 'properties'" [ngClass]="addElements || isSmallScreen ? 'property-preview-panel-addelements': 'property-preview-panel'">
    <app-property-preview #property (closePropertyPanel)="showMenu=''"></app-property-preview>
  </aside>
</div>
